module.exports = __webpack_public_path__ + "static/media/location.b0fc2dc7.png";